if (!customElements.get('caelene-offer-clock')) {
  customElements.define('caelene-offer-clock', class extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.end || '';
      if (raw) {
        if (!/(Z|[+-]\d{2}:\d{2})$/.test(raw)) return;
        this.end = Date.parse(raw);
        if (!Number.isFinite(this.end)) return;
        this.start();
      } else {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          try {
            const stored = Number(sessionStorage.getItem('caelene-cart-timer-v1'));
            this.end = stored > 0 ? stored : Date.now() + 600000;
            sessionStorage.setItem('caelene-cart-timer-v1', String(this.end));
          } catch { this.end = Date.now() + 600000; }
          this.start();
        });
        this.observer.observe(this.parentElement);
      }
    }
    start() {
      this.update();
      if (!this.hidden) this.interval = setInterval(() => this.update(), 1000);
    }
    update() {
      const remaining = Math.floor((this.end - Date.now()) / 1000);
      if (remaining <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        return;
      }
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(remaining % 86400 / 3600);
      const minutes = Math.floor(remaining % 3600 / 60);
      const seconds = remaining % 60;
      const pad = n => String(n).padStart(2, '0');
      this.querySelector('strong').textContent = (days ? days + ' T. ' : '') + [hours, minutes, seconds].map(pad).join(':');
      this.hidden = false;
    }
    disconnectedCallback() { clearInterval(this.interval); this.observer?.disconnect(); }
  });
}
